const multiplyMixBlendMode: { mixBlendMode: 'multiply' } = {
	mixBlendMode: 'multiply',
};

export const RoadBlock = ({ title }: { title: string }) => (
	<svg width="100%" viewBox="0 0 503 503" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
		<title>{title}</title>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M397.398 437C438.408 398.259 464 343.368 464 282.5C464 165.139 368.861 70 251.5 70C134.139 70 39 165.139 39 282.5C39 343.368 64.5916 398.259 105.602 437H397.398Z"
			fill="#FEEDC3"
		/>
		<path
			d="M303.488 141.093C303.488 136.675 307.07 133.093 311.488 133.093H353.256C357.674 133.093 361.256 136.675 361.256 141.093V146.907H303.488V141.093Z"
			fill="#FFC847"
		/>
		<g style={multiplyMixBlendMode}>
			<circle cx="332.372" cy="102.953" r="43.9535" fill="#FFF7E6" />
		</g>
		<circle cx="332.372" cy="102.953" r="23.8605" fill="#FFC847" />
		<circle cx="332.372" cy="102.953" r="15.0698" fill="#FFDC8A" />
		<g style={multiplyMixBlendMode}>
			<rect x="166" y="437" width="18" height="256" transform="rotate(180 166 437)" fill="#DBE1E6" />
		</g>
		<g style={multiplyMixBlendMode}>
			<rect x="356" y="437" width="18" height="256" transform="rotate(180 356 437)" fill="#DBE1E6" />
			<rect width="25.1163" height="8.7907" transform="matrix(-1 1.71417e-09 -4.45856e-06 -1 169.582 437)" fill="#DBE1E6" />
			<rect width="25.1163" height="8.7907" transform="matrix(-1 1.71417e-09 -4.45856e-06 -1 359.535 437)" fill="#DBE1E6" />
		</g>
		<rect x="131.442" y="146.907" width="241.116" height="62.7907" fill="white" />
		<rect x="372.558" y="349.093" width="241.116" height="62.7907" transform="rotate(180 372.558 349.093)" fill="white" />
		<g style={multiplyMixBlendMode}>
			<path d="M127.674 143.14H176.759L218.093 213.465H169.009L127.674 143.14Z" fill="#FB5B63" />
			<path d="M376.326 352.861L327.241 352.861L285.907 282.535L334.991 282.535L376.326 352.861Z" fill="#FB5B63" />
			<path d="M218.093 143.14H267.177L308.511 213.465H259.427L218.093 143.14Z" fill="#FB5B63" />
			<path d="M285.907 352.861L236.822 352.861L195.488 282.535L244.573 282.535L285.907 352.861Z" fill="#FB5B63" />
			<path d="M308.512 143.14H358.068L376.326 174.083V213.465H350.243L308.512 143.14Z" fill="#FB5B63" />
			<path d="M195.488 352.861L145.932 352.861L127.674 321.917L127.674 282.535L153.757 282.535L195.488 352.861Z" fill="#FB5B63" />
			<path
				d="M194.233 115.512V82.8606C194.233 72.4571 185.799 64.0234 175.395 64.0234V64.0234C164.992 64.0234 156.558 72.4571 156.558 82.8606V101.432"
				stroke="#808F99"
				strokeWidth="14"
			/>
			<path d="M136.223 95.7766L176.209 95.7766L156.216 117.34L136.223 95.7766Z" fill="#808F99" />
		</g>
	</svg>
);
